import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LambdaTrackerItem, LambdaTrackerResult } from "models/lambda-tracker";

export interface AdminLambdaTrackerSliceState {
    result: LambdaTrackerResult | null;
    /** Window the cached result was loaded for. */
    days: number;
}

export const initialState: AdminLambdaTrackerSliceState = {
    result: null,
    days: 14,
};

const AdminLambdaTrackerSlice = createSlice({
    name: "admin-lambda-tracker-slice",
    initialState,
    reducers: {
        setLambdaTracker(state, { payload }: PayloadAction<{ result: LambdaTrackerResult; days: number }>) {
            state.result = payload.result;
            state.days = payload.days;
        },
        /** Applies edited settings (name, schedule...) to the cached list item. */
        setLambdaTrackerSettings(state, { payload }: PayloadAction<Partial<LambdaTrackerItem> & { id: string }>) {
            if (!state.result) return;
            const index = state.result.items.findIndex(i => i.id === payload.id);
            if (index === -1) return;
            const { runs, stats, ...settings } = payload;
            state.result.items[index] = { ...state.result.items[index], ...settings };
        },
        invalidateLambdaTracker(state) {
            state.result = null;
        },
    },
});

export const {
    setLambdaTracker,
    setLambdaTrackerSettings,
    invalidateLambdaTracker,
} = AdminLambdaTrackerSlice.actions;

export default AdminLambdaTrackerSlice.reducer;
